import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import Image from '@src/components/image';
import React from 'react';
import { ctaImage } from '../../assets';
import BsPlusCircle from '@src/assets/svgs/transformed/react-icons/bs/BsPlusCircle';

interface Props {
  onClick?: () => void;
  onMouseEnter?: () => void;
  label: string;
  id?: string;
}

const DashboardCtaBtn = ({ onClick, label, onMouseEnter, id }: Props) => {
  return (
    <button
      type="button"
      id={id}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      style={{ minHeight: 128 }}
      className="ss-flex focus:ss-focus-ring ss-bg-primary1-500 ss-text-white ss-p-4 ss-overflow-hidden ss-rounded-lg ss-relative ss-items-center">
      <Image
        variant="eager-load"
        alt=""
        src={ctaImage}
        className="ss-absolute ss--left-6 ss-bottom-0"
      />
      <Box className="ss-flex ss-items-center ss-w-full ss-justify-center ss-gap-3 ss-relative">
        <Text className="ss-font-semibold">{label}</Text>
        <BsPlusCircle width={24} height={24} />
      </Box>
    </button>
  );
};

export default DashboardCtaBtn;
